import { ClipContext } from "MVVM/Views/ClipExperience/@types";

export const getQueryParam = (param: string) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const value = params.get(param);
  return value;
};

export const getClipContextFromUrl = (): ClipContext | null => {
  const contextType = getQueryParam("context");
  const userId = getQueryParam("userId");
  const tab = getQueryParam("tab");
  const source = getQueryParam("source");
  const playlistId = getQueryParam("playlistId");
  const startCursor = getQueryParam("startCursor");
  if (!contextType) return null;

  switch (contextType) {
    case "profile":
      if (!userId) return null;
      return {
        type: "profile",
        metadata: {
          userId,
          tab: tab || undefined,
          source: source || undefined,
          startCursor: startCursor || undefined,
        },
      };
    case "pinned-clips":
      return {
        type: "pinned-clips",
        metadata: {
          userId: userId || undefined,
        },
      };
    case "playlist":
      if (!playlistId) return null;
      return {
        type: "playlist",
        metadata: {
          playlistId,
        },
      };
    case "filtered":
      return {
        type: "filtered",
        metadata: {},
      };
    case "match":
      return {
        type: "match",
      };
    case "default":
    default:
      return {
        type: "default",
        metadata: {},
      };
  }
};
